import { Observable } from 'rxjs';
import { AccountFile, AccountFilesListResponse } from '../types/file.types';
import { signal } from '@angular/core';

export abstract class AccountFilesService {
  accountFilesLoading = signal<boolean>(false);
  abstract getAccountFiles(accountId: number, params?: Record<string, any>): Observable<AccountFilesListResponse>;
  abstract readFile(quoteRequestId: number, fileId: number): Observable<any>;
}
